var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"template-container"},[_c('div',{ref:"navbarRef",class:[
      'template-navbar',
      {
        'template-navbar__impersonate--enabled': _vm.isImpersonateFlag
      }
    ]},[_vm._t("navbar",null,{"isNavbarTransparent":_vm.isNavbarTransparent})],2),_c('div',{staticClass:"template-container__hero"},[_vm._t("hero")],2),_c('div',{ref:"contentRef",staticClass:"template-container__content"},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }